import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';
import { Table, Button, Input, Select } from 'antd';
import { Link } from 'react-router-dom';

const { Option } = Select;

const RoadList = () => {
  const [roads, setRoads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [size, setSize] = useState(20);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchField, setSearchField] = useState('id');
  const [sortField, setSortField] = useState('id');
  const [sortOrder, setSortOrder] = useState('asc');

  const API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/road/pagination';
  const SEARCH_API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/road/search';
  const EXPORT_API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/road/export';

  const fetchRoads = async () => {
    try {
      setLoading(true);
      const params = { page, size, sortField, sortOrder };
      const response = await axios.get(API_URL, { params });
      setRoads(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const searchRoads = async () => {
    try {
      const response = await axios.get(SEARCH_API_URL, {
        params: { keyword: searchKeyword, searchField },
      });
      setRoads(response.data);
      setTotalPages(1);
    } catch (error) {
      setError(error);
    }
  };

  const exportRoads = () => {
    window.open(EXPORT_API_URL, '_blank');
  };

  useEffect(() => {
    fetchRoads();
  }, [page, size, sortField, sortOrder]);

  if (error) {
    return <div className="p-4 text-red-500">Error: {error.message}</div>;
  }

  const columns = [
    {
      title: 'क्र.सं',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'सुरुवात टोल',
      dataIndex: 'startTole',
      key: 'startTole',
    },
    {
      title: 'सुरुवात बिन्दु',
      dataIndex: 'startLandMark',
      key: 'startLandMark',
    
    },
    {
      title: 'अन्तिम टोल',
      dataIndex: 'endTole',
      key: 'endTole',
    },
    {
      title: 'अन्तिम बिन्दु',
      dataIndex: 'endLandMark',
      key: 'endLandMark',
    
    },
    {
      title: 'चौडाइ',
      dataIndex: 'currentPurposeWidth',
      key: 'currentPurposeWidth',
     
    },
    {
      title: 'कार्य',
      key: 'details',
      render: (text, record) => (
        <Link 
          to={`/road/${record.id}/details`} 
          className="text-blue-500 hover:underline"
        >
          बिस्तृत विवरण
        </Link>
      ),
    },
  ];
  const rowClassName = (record, index) => {
    return index % 2 === 0 ? 'odd-row' : 'even-row';
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-1 pt-20 px-4 md:px-10">
        <Sidebar />
        <div className="w-full md:ml-56 p-4">
          <h1 className="text-2xl font-semibold mb-4 pt-10">बाटोको सुची</h1>

          {/* Search and Filter Section */}
          <div className="flex flex-col gap-4 mb-6">
            {/* Search Input */}
            <div className="flex flex-col md:flex-row items-center justify-end gap-2 w-full">
              <Select
                value={searchField}
                onChange={(value) => setSearchField(value)}
                className="w-full md:w-32"
                size="large"
              >
                <Option value="id">क्र.सं.</Option>
                <Option value="startTole">सुरुवात टोल</Option>
                <Option value="endTole">अन्तिम टोल</Option>
              </Select>
              <Input
                placeholder="खोज..."
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                className="w-full md:w-48"
                size="large"
              />
              <Button
                type="primary"
                onClick={searchRoads}
                className="w-full md:w-auto"
                size="large"
              >
                खोज
              </Button>
            </div>

            {/* Sorting and Export Section */}
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              {/* Sorting Controls */}
              <div className="flex flex-col md:flex-row items-center gap-2 w-full">
                {/* Sort By */}
                <div className="flex items-center gap-2">
                  <label className="whitespace-nowrap">Sort By:</label>
                  <Select
                    onChange={(value) => setSortField(value)}
                    value={sortField}
                    className="w-full md:w-32"
                  >
                    <Option value="id">क्र.सं.</Option>
                    <Option value="startTole">सुरुवात टोल</Option>
                    <Option value="endTole">अन्तिम टोल</Option>
                    <Option value="currentPurposeWidth">चौडाइ</Option>
                  </Select>
                </div>

                {/* Sort Order */}
                <div className="flex items-center gap-2">
                  <label className="whitespace-nowrap">Order:</label>
                  <Select
                    onChange={(value) => setSortOrder(value)}
                    value={sortOrder}
                    className="w-full md:w-32"
                  >
                    <Option value="asc">माथिबाट</Option>
                    <Option value="desc">तलबाट</Option>
                  </Select>
                </div>

                {/* Export Button */}
                <Button 
                  type="primary" 
                  onClick={exportRoads} 
                  className="w-full md:w-auto"
                >
                  Export
                </Button>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto">
            <Table
              dataSource={roads}
              columns={columns}
              rowClassName={rowClassName}
              pagination={false}
              bordered
              className="w-full custom-table"
            />
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-end mt-4 gap-2">
            <Button 
              onClick={() => setPage(page - 1)} 
              disabled={page === 0}
            >
              Previous
            </Button>
            <Button 
              onClick={() => setPage(page + 1)} 
              disabled={page >= totalPages - 1}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoadList;